import React, { useContext, useEffect, useState } from "react";
import error from "../../assets/errorMsg.svg";
import eyeClose from "../../assets/password/eyeClose.svg";
import eyeOpen from "../../assets/password/eyeOpen.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { MyContext } from "../../context/Context";
import { AuthContext } from "../../services/AuthProvider";

const MobileField = (props) => {
  const {
    uniqueId,
    textField,
    pswd,
    setPswd,
    errorMsg,
    createPswd,
    setCreatePswd,
    isOtp,
    isOtpTrue,
    otp,
    setOtp,
    // createConfPswd,
    // setCreateConfPswd,
  } = props;
  const { mobileNumber, setMobileNumber } = useContext(MyContext);
  const { handleForgotPassword, setOtpCode } = useContext(AuthContext);
  const [isPswd, setIsPswd] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  const handleForgotPasswordClick = async () => {
    await handleForgotPassword()
      .then(() => navigate("/forgot-password"))
      .catch((err) => console.log("err", err));
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    // Check if the value is a number and contains only up to 10 digits
    if (value.length <= 10 && /^\d*$/.test(value)) {
      setMobileNumber(value);
    }
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPswd(value);
  };

  const handleCreatePasswordChange = (e) => {
    const value = e.target.value;
    setCreatePswd(value);
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
    setOtpCode(e.target.value);
  };

  useEffect(() => {
    setIsPswd(true);
  }, [location.pathname]);

  const returnLoginUI = () => {
    return (
      <div className="w-full border border-[#989898] px-5 py-3 gap-1 flex rounded-[10px]">
        <div className="text-[#1C75BC] text-[16px] font-bold">+91 -</div>
        <input
          type="text"
          placeholder="Mobile"
          value={mobileNumber}
          onChange={handleInputChange}
          className="w-[80%] outline-none"
        />
      </div>
    );
  };

  const returnPasswordUI = () => {
    return (
      <div className="w-full border border-[#989898] px-5 py-3 gap-1 flex justify-between rounded-[10px]">
        <input
          type={isPswd ? "password" : "text"}
          value={pswd}
          onChange={handlePasswordChange}
          className="w-full outline-none"
        />
        <div
          onClick={() => setIsPswd((prev) => !prev)}
          className="w-5 h-5 cursor-pointer"
        >
          {isPswd ? (
            <img src={eyeClose} alt="" />
          ) : (
            <img src={eyeOpen} alt="EEEE" />
          )}
        </div>
      </div>
    );
  };

  const returnCreatePasswordUI = () => {
    return (
      <div className="w-full">
        <div className="w-full border border-[#989898] px-5 py-3 gap-1 flex justify-between items-center rounded-[10px]">
          <input
            type={isPswd ? "password" : "text"}
            value={createPswd}
            onChange={handleCreatePasswordChange}
            className="w-full outline-none"
          />
          <div
            onClick={() => setIsPswd((prev) => !prev)}
            className="w-5 h-5 cursor-pointer"
          >
            {isPswd ? (
              <img src={eyeClose} alt="" />
            ) : (
              <img src={eyeOpen} alt="" />
            )}
          </div>
        </div>
        {uniqueId === "ConfigurePswd" && (
          <div className="w-full flex justify-between">
            <div></div>
            <div className="text-[#1C75BC] font-medium text-[10px] flex">
              <div
                className={`${createPswd.length > 15 ? "text-red-500" : ""}`}
              >
                {createPswd.length}
              </div>
              <div>/15</div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const returnIsOtpUI = () => {
    return (
      <input
        type="text"
        placeholder="XXXXXX"
        value={otp}
        onChange={handleOtpChange}
        className="w-full border border-[#989898] px-5 py-3 rounded-[10px] outline-none"
      />
    );
  };

  return (
    <section className="flex flex-col w-full">
      <section className="flex flex-col items-start gap-[5px] w-full p-4">
        <div className="flex items-center gap-2 justify-between">
          <div className="text-[16px] font-semibold">{textField}</div>
          {uniqueId === "ConfigurePswd" && (
            <div className="text-[10px] text-[#828282]">
              (should be 6-15 characters){" "}
            </div>
          )}
        </div>
        {location.pathname.replace(/\/$/, "") === "/login" && returnLoginUI()}
        {location.pathname.replace(/\/$/, "") === "/password" &&
          returnPasswordUI()}
        {(location.pathname.replace(/\/$/, "") === "/create-password" ||
          isOtpTrue) &&
          returnCreatePasswordUI()}
        {isOtp && returnIsOtpUI()}
      </section>
      <div className="w-full flex justify-between px-4">
        {errorMsg ? (
          <div className="flex items-center gap-[5px] w-full">
            <div className="grid place-items-center w-4 h-4">
              <img src={error} className="w-full h-auto" alt="" />
            </div>
            <div className="w-full text-[#FF0000] font-light text-xs">
              {errorMsg}
            </div>
          </div>
        ) : (
          <div></div>
        )}
        {location.pathname.replace(/\/$/, "") === "/password" && (
          <button
            className="text-[#1C75BC] font-semibold flex text-sm gap-1 leading-5"
            onClick={handleForgotPasswordClick}
          >
            <div>Forgot</div><div>password?</div> 
          </button>
        )}
      </div>
    </section>
  );
};

export default MobileField;
